import type { Account } from '@foundershub/api-client';
import { useAccountRequired } from '../store';

interface VStatus {
  canRequest: boolean;
  status: Status;
  visible: boolean;
}

export interface ModalProps {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

export function useVerificationStatus(): { bv: VStatus; dv: VStatus } {
  const account = useAccountRequired();

  const bvState = account['bv_state']?.toLowerCase() as Lowercase<State> | undefined;
  const dvState = account['dv_state']?.toLowerCase() as Lowercase<State> | undefined;

  const bv = {
    canRequest: account.bv_state === null,
    visible: true,
    status: bvState && bvState in stateToStatus ? stateToStatus[bvState] : 'not-verified',
  };
  const dv = {
    canRequest: account.dv_state === null,
    visible: true,
    status: dvState && dvState in stateToStatus ? stateToStatus[dvState] : 'not-verified',
  };

  if (!account.is_incorporated || !account.street_address) {
    bv.visible = false;
    bv.canRequest = false;
  }

  if (bv.status !== 'verified') {
    dv.visible = false;
    dv.canRequest = false;
  }

  return { bv, dv };
}

export type Status = 'not-verified' | 'appeal-in-review' | 'in-review' | 'verified' | 'failed';

type State = NonNullable<Account['dv_state']>;

const stateToStatus: Record<Lowercase<State>, Status> = {
  accepted: 'in-review',
  'not started': 'in-review',
  'in progress': 'in-review',
  pass: 'verified',
  fail: 'failed',
  error: 'in-review',
  cancelled: 'not-verified',
  'pass with override': 'verified',
  'fail with override': 'failed',
  'appeal submitted': 'appeal-in-review',
  'onevet took too long': 'in-review',
  'pass with restrictions': 'verified',
  expired: 'failed',
};
